export const PRODUCT_IMAGE_KEYPHRASES = ['product', 'product image'];

export const IMAGE_AREA_KEYPHRASES = [
  'image area',
  'background'
];

export const HEADLINE_KEYPHRASES = ['headline'];
